import { createSelector } from 'reselect';
import { getRoutingState } from 'src/modules/routing/selectors/getRoutingState';

export const getCurrentState = createSelector([
  getRoutingState,
], (state) => state.currentState);
